import {
  AnisotropyPlugin,
  AssetExporterPlugin,
  AssetManagerPlugin,
  BloomPlugin,
  CameraViewPlugin,
  ChromaticAberrationPlugin,
  ClearcoatTintPlugin,
  CombinedPostPlugin,
  ContactShadowGroundPlugin,
  CustomBumpMapPlugin,
  DepthOfFieldPlugin,
  DiamondPlugin,
  DropzonePlugin,
  FilmicGrainPlugin,
  FrameFadePlugin,
  FullScreenPlugin,
  GammaCorrectionPlugin,
  GBufferPlugin,
  GLTFAnimationPlugin,
  GLTFDracoExportPlugin,
  GroundPlugin,
  HDRiGroundPlugin,
  IViewerApp,
  KTX2LoadPlugin,
  LUTPlugin,
  NoiseBumpMaterialPlugin,
  PresetLibraryPlugin,
  ProgressivePlugin,
  RandomizedDirectionalLightPlugin,
  Rhino3dmLoadPlugin,
  SceneLoopPlugin,
  SSAOPlugin,
  SSContactShadows,
  SSRPlugin,
  TemporalAAPlugin,
  ThinFilmLayerPlugin,
  TonemapPlugin,
  VelocityBufferPlugin,
  VignettePlugin,
} from "webgi";

export async function addBasePlugins(
  viewer: IViewerApp,
  {
    ground = true,
    bloom = true,
    depthTonemap = true,
    enableDrop = false,
    canvasMode = "",
    downloadFile = "",
    camId = "2",
    preDownload = "",
  } = {}
) {
  await viewer.addPlugin(AssetManagerPlugin);
  await viewer.addPlugin(Rhino3dmLoadPlugin);
  if (downloadFile === "true" || preDownload === "true") {
    await viewer.addPlugin(AssetExporterPlugin);
    await viewer.addPlugin(GLTFDracoExportPlugin);
  }
  await viewer.addPlugin(GBufferPlugin);
  // await viewer.addPlugin(FullScreenPlugin);
  // if (enableDrop) await viewer.addPlugin(DropzonePlugin);
  await viewer.addPlugin(new ProgressivePlugin(32));
  await viewer.addPlugin(new CombinedPostPlugin());
  await viewer.addPlugin(new ChromaticAberrationPlugin());
  await viewer.addPlugin(new TonemapPlugin(depthTonemap || !viewer.useRgbm));
  await viewer.addPlugin(new LUTPlugin());
  await viewer.addPlugin(new VignettePlugin());
  await viewer.addPlugin(new FilmicGrainPlugin());
  await viewer.addPlugin(new GammaCorrectionPlugin());

  await viewer.addPlugin(SSRPlugin);
  await viewer.addPlugin(SSAOPlugin);
  await viewer.addPlugin(DiamondPlugin);
  // await viewer.addPlugin(FrameFadePlugin);
  // await viewer.addPlugin(GLTFAnimationPlugin);
  if (canvasMode === "capture" && camId !== "7" && camId !== "5") {
    await viewer.addPlugin(ContactShadowGroundPlugin);
  } else {
    if (ground) await viewer.addPlugin(GroundPlugin);
  }
  if (bloom) await viewer.addPlugin(BloomPlugin);
  await viewer.addPlugin(AnisotropyPlugin);
  // await viewer.addPlugin(ThinFilmLayerPlugin);
  // await viewer.addPlugin(NoiseBumpMaterialPlugin);
  // await viewer.addPlugin(CustomBumpMapPlugin);
  // await viewer.addPlugin(ClearcoatTintPlugin);
  await viewer.addPlugin(VelocityBufferPlugin, false);
  await viewer.addPlugin(TemporalAAPlugin);
  await viewer.addPlugin(CameraViewPlugin);
  // await viewer.addPlugin(RandomizedDirectionalLightPlugin, false);
  await viewer.addPlugin(HDRiGroundPlugin, false);
  await viewer.addPlugin(DepthOfFieldPlugin, false);
  await viewer.addPlugin(SSContactShadows, false);
  // await viewer.addPlugin(KTX2LoadPlugin);
  // await viewer.addPlugin(PresetLibraryPlugin);
  // await viewer.addPlugin(SceneLoopPlugin);
}
